import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export function OverviewIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 13L5.38889 10.6111M3 17V21H21M13 17V14M8 17V16M4.11111 7.44444C4.11111 9.89904 6.10096 11.8889 8.55556 11.8889C11.0102 11.8889 13 9.89904 13 7.44444C13 4.98985 11.0102 3 8.55556 3C6.10096 3 4.11111 4.98985 4.11111 7.44444ZM18 17C18 12.3137 18 9.68629 18 5V17Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
